<template>
	<el-dialog :visible.sync="visible" width="800px" custom-class="sell_dialog sell_pop" destroy-on-close @closed="closed">
		<div class="card">
			<div class="title">	<img :src="require(`@/assets/image/sell.png`)"></div>
			<div class="content"><a class="btn" href="https://tb.53kf.com/code/client/696ac86f721b23bfe7eb4b6e24f45b349/1" target="_blank">
					<div class="btnHead"><span></span>
						

					</div>
					<div class="btnBody"> 1.红六美工截取账号详情图，编辑标题挂售到官方网站（约30分钟）<br><br> 2.平台在交流群等渠道同步宣传，提高曝光度以匹配更多买家<br><br>
						3.买家确认交易并完成付款，由客服拉群聊安排完成交易流程<br><br> 4.买卖双方游戏资料交接完成后，财务实时放款，交易完成<br><br>
						5.注：商品上架期间卖家可以正常使用账号，如需更新截图请联系客服进行修改 </div><button type="button"
						class="el-button el-button--text"><span>如何卖号</span></button>
				</a><a class="btn" href="https://tb.53kf.com/code/client/696ac86f721b23bfe7eb4b6e24f45b349/1" target="_blank">
					<div class="btnHead"><span></span>



					</div>
					<div class="btnBody"> 1.号商对账号进行报价，号主决定是否回收。<br><br> 2.快速变现，当天收款。<br><br>
						3.所有交易一律由官方客服拉组担保中介交易<br><br> 4.注：合作号商可能并非红六官方人员。 </div>
					<button type="button" class="el-button el-button--text"><span>如何回收</span></button>
				</a><a class="btn" href="https://tb.53kf.com/code/client/696ac86f721b23bfe7eb4b6e24f45b349/1" target="_blank">
					<div class="btnHead"><span></span>



					</div>
					<div class="btnBody"> 1.双方私下联系谈好价格，确认账号详情后联系红六客服<br><br> 2.客服直接拉组中介交易<br><br>
						3.担保中介不限游戏类目，支持市面所有游戏账号交易<br><br></div><button type="button"
						class="el-button el-button--text"><span>如何找担保中介</span></button>
				</a></div>
				<img :src="require(`@/assets/image/close.png`)" class="escBtn" @click="closed">

		</div>
		<br />
	</el-dialog>
</template>
<script>
	export default {
		props: {},
		components: {},
		data() {
			return {
				logined: Boolean(localStorage.getItem('usertoken')),
				visible: false,


				list: [],
				vip: 0,

			}
		},
		computed: {

			isMobile() {
				return this.$store.getters.isMobile
			},
			lang() {
				return this.$store.getters.lang
			},
			darken() {
				return this.$store.getters.darken
			},
			grade() {
				let grade = {}
				for (let i in this.grades) {
					grade[Number(i) + 1] = this.grades[i]
				}
				return grade
			},


		},
		watch: {
			visible(v) {
				if (v) {

				} else {
					this.$router.replace(this.$route.path)
				}
			},

		},
		created() {

		},
		methods: {

			closed() {
				this.visible = false
			},




		},
	}
</script>

<style>


	.sell_pop .card {
		min-height: 493px;
		border-radius: 5px;
		background: linear-gradient(180deg, #bfcdf2, #fff);
		position: relative
	}

	.sell_pop .card .title {
		height: 77px;
		border-radius: 5px 5px 0 0;
		background: linear-gradient(97deg, #6e7ca0, #051335);
		box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .31);
		display: flex;
		justify-content: center;
		align-items: center
	}

	.sell_pop .card .content {
		padding: 30px 23px 41px;
		display: flex;
		flex-direction: row;
		justify-content: space-between
	}

	.sell_pop .card .content .btn {
		margin: 0 3px;
		width: 250px;
		background: #fff;
		border-radius: 5px;
		box-shadow: 0 4px 9px 0 rgba(0, 0, 0, .2);
		cursor: pointer;
		position: relative
	}

	.sell_pop .card .content .btn button {
		position: absolute;
		bottom: 15px;
		padding: 0;
		left: 50%;
		transform: translateX(-42%);
		font-size: 12px;
		font-family: PingFang SC, PingFang SC-Regular;
		font-weight: 400;
		color: #8b9bcb;
		height: 15px;
		line-height: 12px;
		border-bottom: 1px solid #8b9bcb;
		border-radius: unset
	}

	.sell_pop .card .content .btn button:before {
		content: "";
		position: absolute;
		left: -17px;
		top: -1px;
		width: 15px;
		height: 15px;
		display: inline-block;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAA/tJREFUSEudV0FoHGUU/t40SmQmkEOEVrdQT/agILKztdJDgwqRWmxBqIdCFXeSBgXT2kysPWwWBOPuSiqtpJtJocWL4sGCFQMqq6ioO3szQnpSYWsWsoeFTqSQzTz5J7PJ7mb+mdnMYS//e+/733vf+9+3hBhfJlPq0xLaMQZGiPEEgIMgDG26co2BKjH9BqZF599732ezw/ejwlKYQWa2NKhp2tsAJgAMRgXzzxsMuvafi4+mx5J1mY8UuFD8/QwryuUeALsxagyeMI3U50HgO4BFWdWEOkegdMwMQ80YuLZWdc51l78DOJMp9WsJ9UuARkKi/SB6CeJlYUNEgy7zMwScALBX4rfoVJ3j2exws3XeAZyz7DkCzgY5CwKB+bQ5mvox6FxceiChXmFJpRi8YBopYwdwziqfItBngTdm1JsbTf3i+OG/PYD9A6dcdo+AlT4ClnndvWm+maoJ37xlfwrgdFAc13Vfmxo7dNOrlPiZLlaGVIX/kJbKxdnJMb2Y+aSkaQ9qvwLeSG1/jPoePHD0/OhTf4pJUFV1lYj6AsAbjuM8lj033PCAC1b5Awa9K+lPw6k6+wQ58pY964/WDlMGFk1Df9HLet7+FoTnJfGmJw09S5uE0lZkY8PMt83R1HE/4Or2w9EZlsH3TSP1kG93BYS3QhJ5mPLFyjEofFvGYjEOpqGPTxdLQ6qircrttoFz8/YcUTBJff8TlJ+3w24HMOogVAGInnX2tr3NjFvmqH7SJ1gJwNGwZChnlW0CJUPmNvqojfUfXrcfpw1ekpBrMxbjZ8pb5RWAZIMfDQrUmPCKmdZ/8fnyTVi2fsA65S2b40QPshGPStNdf+G9sWeXY756W2F2DSxYvN4k/dK4vuS/A1/EyLQDWDDV36095Z6eNPTrfnntMOIFRK0JVv8EwpGeIBl1566zP+pRCRm9CoUtBqlj26OSs8or1Cs5GVdFj18GcKuXjJnohplOvu7PbO/kdOkl8WQKPSX6HFfaiDl0GOzJGiI60MulAXhvv7ck8padEUuqxwC7MmfQjGkkL3rAvqj7K3bWjO82eCOrKMqjxHRVtjiC2Lzm0pNCBG4pkMJC5Qwz34iTBtGeAxfST//jVWuhMgXmmTh+DH61Jf46pE/BqlgMjhR5roKDU2/od/w2XQLwfhRwa8u17LrFXp+WUL+KEHtgcEXoBzD2gjBDoP4IYCH2TrYrzSB5268mtFmZ6IvKrPucQQtr1Xvj7QrTmwZZIF/8CUG/283VIKKJC+mkJ+66v9C/MIViZQiK+w6DhOSNO+cNAJcdx/lYiDpZYqHALSdvETwy8ByIR5g88Z7Y2uFCoQiJS1giQPTy6+6yBoH/D4tmsjqB/JWwAAAAAElFTkSuQmCC) no-repeat;
		background-size: contain
	}

	.sell_pop .card .content .btn button:hover {
		color: #fcad13;
		border-bottom: 1px solid #fcad13
	}

	.sell_pop .card .content .btn button:hover:before {
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAA+1JREFUSEudV02IFFcQ/qq7M6uJO8x0b8AQBT3FQzQXBQ8ehCisGPGnBzVBMAsGVhCywYOKB10Q3EOCG1ZwQwwqgRB1xggaMpCEJCQhAXNaN7CeVHbAIc70NLMmLrPdXfJ6erLz06+nd/r6qup7Ve+rqq8JMT4+A819K7UTnjoI4jcBrANowHdlFBkoELw/QcjPVis/rh3CfLewFGVQuZJKJZPKhwyMAJTqFqx+zjYzTT6v1T5JvjdXkvlIgZ2scRjE4/EB2yAYRRCPaKZ1PQy8A9gv6wb9EkBH4mXYxYoxOTtX/qi9/C3AD69g2eqk/g1Ag9JwjJ9J8fIKeEbYuJ4qnmAzgD0grAzzY3Bem7J20SicxnkLsJM1LoEwLAEtqOQeon32L2HnwaUn5JXiy5ppfdAB7OT0AwB9HQ7KpYWat2n5u/YjH6DfOADiLQA08mjmOc9fW7H/36LwdbLGlyAcCo3DeF/LlK+JMz/j6lf9Ay8nEvdlpSJ4w6pZ+eyfG1iRVvU/CCRaqunjksrYShnrb9EJ/UnlKUBaJzjbc1VvbXrItn1gN2ucZ8JJSbb2bNV6TZDDzekXGDQisctrprWjnrX+PYi2hbOZz6qmNUrB2zyRtg3jrpYp7/ID5nSRSX1wtH+MeS1TXl63S08AyjFZIuqU9So5ufROQLkbweJJLVM+6j9HX+JphN0icDRJAXL3kJMzJgBIbidguESMgkfQOt+25Rq3NbO8NyDYTyBsjUqGFrLGPSJslBrFOlhkPd8YeMNVvelwcjWC8W/kZI0nMjbHw0RRJS9DZuX3oNW+i8zWD8olUWqOBRBuVHAZ2/sy5ZlYU68pRu/AjHnX8Tb1HaxMB3PgZvdMF5EpskUiS8FHNNP6QmS6Kqnf60K81kiMIi3k9F8JJMbfEj4uzVat1d2HiqSTGX8JckUtBoln01DphZzsXSTnprEbCm4vIV3ByquaaQ3Vp1Qv5PTeoWDxi1EYU9r4OusZiANZQ2uWeGl/9teXRE4/w6CzSwvQmzWzN/ZSpnLKBw5W2cO4WTP4B7g8Siq9DuCidHG0341R/K9WWy9E4P8KxLmVOgxWr8bJQ4W7hkz7sV+tW+kTzMpYHD+ADzbEX6v0yemfxxF5qlZbR7vnHvjAWeM0E851BWb4W65h1wIcEO1OpNgT3BJ9SPwxMVYyaAyEZVHAQuwVqtbeZqXZIW+DQX8hQvR1Ta5tTF1Wp6yjzQpTnMsFvRB/TOO9by62wTTSEHftt438hRHD/5VE4jgTD8dlvPiFIWC8WvU+FaJOVp5I4IZTfeWl3waUQWZsJmDVYiX8QTIDpmkw8up0+dv2soaBvwCOTq+j2lH63gAAAABJRU5ErkJggg==) no-repeat;
		background-size: contain
	}

	.sell_pop .card .content .btn .btnHead {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 0 0 20px
	}

	.sell_pop .card .content .btn .btnHead span {
		width: 40px;
		height: 8px;
		border-radius: 0 0 8px 8px;
		background: #fca700;
		margin: 0 0 25px
	}

	.sell_pop .card .content .btn .btnBody {
		padding: 0 19px 47px 24px;
		font-size: 14px;
		font-family: PingFang SC, PingFang SC-Light;
		font-weight: 300;
		text-align: LEFT;
		color: #82a2c8;
		line-height: 17px;
		text-align: justify;
		text-justify: newspaper;
		word-break: break-all
	}

	.sell_pop .card .content .btn:hover {
		box-shadow: 0 2px 23px 0 rgba(252, 167, 0, .4);
		animation: header_fourMove-data-v-7ff3d1cd .2s linear infinite;
		animation-fill-mode: forwards;
		animation-iteration-count: 1
	}

	@keyframes header_fourMove-data-v-7ff3d1cd {
		0% {
			transform: translateY(0)
		}

		to {
			transform: translateY(-10px)
		}
	}

	.sell_pop .card .escBtn {
		position: absolute;
		bottom: -50px;
		left: 390px;
		cursor: pointer
	}
</style>